export const destinations = [
  {
    id: 'lonavala',
    name: 'Lonavala',
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/lonavla%20WEBP.webp?updatedAt=1752469650936',
    order: 0,
    isVisible: true,
    propertyCount: 0
  },
  {
    id: 'karjat',
    name: 'Karjat',
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/Karjat%20WEBP.webp?updatedAt=1752469650973',
    order: 1,
    isVisible: true,
    propertyCount: 0
  },
  {
    id: 'alibag',
    name: 'Alibag',
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/Alibag%20WEBP.webp?updatedAt=1752469650891',
    order: 2,
    isVisible: true,
    propertyCount: 0
  },
  {
    id: 'igatpuri',
    name: 'Igatpuri',
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/igatpuri.webp?updatedAt=1752469842641',
    order: 3,
    isVisible: true,
    propertyCount: 0
  },
  {
    id: 'panchgani',
    name: 'Panchgani', 
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/Panchgani.webp?updatedAt=1752469842646',
    order: 4,
    isVisible: true,
    propertyCount: 0
  },
  {
    id: 'neral',
    name: 'Neral',
    imageUrl: 'https://ik.imagekit.io/VillaKosh/Destinations%20/neral%20WEBP.webp?updatedAt=1752469650923', 
    order: 5,
    isVisible: true,
    propertyCount: 0
  }
];